import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-headphones-mic",
  "use": "icon-headphones-mic-usage",
  "viewBox": "0 0 1000 1000",
  "content": "<symbol viewBox=\"0 0 1000 1000\" id=\"icon-headphones-mic\"><path d=\"M968 555q0-15-2-56.5t-3-55.5q-13-118-78-213-63-93-162-145-102-54-220-54-124 0-229 60-103 58-166 159-65 104-71 229-3 44-3 69v13q-2 8-2 17v196q0 32 23 55t55 23h79q32 0 55-23t23-55V578q0-32-23-55t-55-23h-79q-8 0-16 2l1-20q6-110 63-201 55-88 145-139 92-52 200-52 103 0 192 47 86 46 142 126 56 83 68 186 1 14 3 53-10-2-18-2h-78q-32 0-54.5 23T735 578v195q0 22 11 40t30 28l-188 74v-5q0-12-8.5-20.5T559 881h-88q-12 0-20.5 8.5T442 910v30q0 12 8.5 20.5T471 969h141l301-119q6-2 10-7 20-9 32.5-28t12.5-42V578q0-6-1-14 1-5 1-9zm-858 3h79q8 1 13.5 6.5T208 578v196q0 8-5.5 13.5T189 793h-79q-8 0-13.5-5.5T91 774V578q0-8 5.5-13.5T110 559v-1zm683 20q0-8 5.5-13.5T812 559h78q8 0 14 5.5t6 13.5v195q-1 8-6.5 13.5T890 792h-78q-8 0-13.5-5.5T793 773V578z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/headphones-mic.svg
// module id = 1127
// module chunks = 2